
import {
  onMounted,
  ref,
  onUnmounted,
  defineComponent,
} from 'vue';
import menuConfig from '@/configs/menuHCongifg';

export default defineComponent({
  emits: ['mapElementChange',],
  setup (props,context) {
  // 展开数据源名称
    const openName = ref<string>('pm');
    // 数据源(父级)type类型
    const sourceType = ref<number>(1);

    // 选中要素高亮
    const activeItem = ref<string>('');

    // 选中要素的indexName
    const legendName = ref<string>('');
    const active = ref<boolean>(false);

    // 当前图层名称
    const currentMapLayer = ref<string>('vector');
    const layerFlag = ref<boolean>(true);

    const menuList = [
      {
        key: 'pm',
        value: '站点',
        class: 'pmOpen',
        config: 1,
        icon: 'icon-diqiu',
        childrenIndex: 1,
      },
    ];

    const resetMenuConfig = (selectecdMenu:any,isChange:boolean) => {
      menuConfig.forEach((items:any) => {
        if (items.clidren) {
          items.clidren.forEach((item:any) => {
            if (selectecdMenu.param !== item.param || selectecdMenu.parent !== item.parent) {
            // eslint-disable-next-line no-param-reassign
              item.isSelected = false;
            }
          });
        }
      });
    };

    /**
     * 点击数据源
     * @param {string} name  高亮参数
     * @param {string} key 选中父项的type
     * @return {void}
     */
    const handleOpen = (name: string, key: number): void => {
      if (openName.value !== name) {
        openName.value = name;
        sourceType.value = key;
        // 默认选择
        const index:number = menuConfig.findIndex((menu) => menu.type === name);

        const menu = menuConfig[index];

        const { clidren, } = menu;

        let first:any = clidren?.find((cur:any,i) => i === key);

        if (!first) {
          first = clidren?.find((cur:any,i) => i === 0);
        }
        activeItem.value = first.param;
        legendName.value = first.type;
        // 切换菜单是否在同一父菜单下,isOldMenuAtSameParent
        first.isOMSP = false;
        first.isSelected = true;
        context.emit('mapElementChange',first);
      }
    };

    /**
     * 点击要素
     * @param {string} param  高亮参数
     * @param {string} indexName 选中子项的indexName
     * @return {void}
     */
    const handleItemClick = (toolsSelectedParam:any) => {
      if (activeItem.value === toolsSelectedParam.param) {
        activeItem.value = '';
        legendName.value = '';
      } else {
        activeItem.value = toolsSelectedParam.param;
        legendName.value = toolsSelectedParam.type;
      // 要素（子项）
      }

      // eslint-disable-next-line no-param-reassign
      toolsSelectedParam.isSelected = !toolsSelectedParam.isSelected;
      resetMenuConfig(toolsSelectedParam,true);
      // 切换菜单是否在同一父菜单下,isOldMenuAtSameParent;
      // eslint-disable-next-line no-param-reassign
      toolsSelectedParam.isOMSP = true;
      context.emit('mapElementChange',toolsSelectedParam);
    };

    onMounted(() => {
      const menu = menuConfig[1];
      const { clidren, } = menu;
      const first:any = clidren?.find((cur:any,index) => index === 1);

      first.isSelected = true;
      first.isOMSP = false;
      activeItem.value = first.param;
      legendName.value = first.type;
    });
    onUnmounted(() => {
    //
    });

    return {
      menuConfig,
      openName,
      sourceType,
      activeItem,
      legendName,
      active,
      currentMapLayer,
      layerFlag,
      menuList,
      handleOpen,
      handleItemClick,
    };
  },
});
